<template lang="pug">
  .navigation-menu
    .header-section.bb-1.pb-3
      .close-button.d-lg-none(@click="toggleSidenav('sidenav-close-button', 'open', false)")
        x-icon
      sidenav-account-info.section-title
    .navigation-ul.scrollable-area.overflow-y(style="padding-right: 1rem;")
      //router-link.navigation-li(:to="{name: 'First Steps'}")
        .d-flex.align-items-center
          home-icon.icon-md.mr-3
          span Inicio
      div(v-for="menu in navigationMenu" v-if="menu.plugins.length")
        .navigation-li.section(v-b-toggle="menu.section")
          .d-flex.align-items-center.justify-content-between.flex-nowrap
            span {{ menu.section }}
            chevron-down-icon.icon-md.collapse-chevron-icon
        b-collapse(:id="menu.section", :visible="isSomeActive(menu.paths) || menu.plugins.length === 1")
          router-link.navigation-li(v-for="(route, index) in menu.plugins", :to="{name: route.name, params: route.params || {}}", :key="index", :class="{'route-matched-active': isSectionActive(route.name)}")
            .d-flex.align-items-center
              component.mr-3.icon-md(:is="route.icon")
              span {{ route.menu_name }}
      router-link.navigation-li.mt-4.negative-route(:to="{name: 'root'}", custom, v-slot="{navigate}")
        .d-flex.align-items-center(@click="navigate", role="link")
          log-out-icon.icon-md.mr-3
          span Salir de cuenta
</template>

<script>
import { createNamespacedHelpers, mapActions, mapGetters } from 'vuex'
import { EventBus } from '@/helpers/eventBus'
import SidenavAccountInfo from '@/components/SidenavAccountInfo.vue'

const accountController = createNamespacedHelpers('account')
const organizationController = createNamespacedHelpers('organization')

export default {
  data () {
    return {
      menuList: [
        { section: 'Construir', paths: ['Flow', 'Widget', 'Variable', 'Rule', 'Entities', 'Sequences', 'Manual'] },
        { section: 'Entrenar', paths: ['Learning', 'Training', 'Graph Answers', 'Knowledge'] },
        { section: 'CRM', paths: ['Account agents', 'Inbox', 'Chats', 'Contacts'] },
        { section: 'Análisis', paths: ['KPI', 'Account cases', 'Insights', 'Metric', 'Report', 'Objectives', 'Activity Logs'] },
        { section: 'Ecommerce', paths: ['Products Categories', 'Products', 'Delivery', 'Orders'] },
        { section: 'Crecimiento', paths: ['Campaigns'] },
        { section: 'Developers', paths: ['Webhooks', 'API'] },
        { section: 'Administrar', paths: ['Settings', 'Customization'] }
      ]
    }
  },
  computed: {
    ...accountController.mapState({
      account: state => state.account
    }),
    ...organizationController.mapState({
      organization: state => state.organization,
      plugins: state => state.plugins
    }),
    ...organizationController.mapGetters(['parsedPlugins']),
    isEcommerce () {
      return (new RegExp('^konverza-ecommerce', 'i')).test(this.account.type)
    },
    showTutorial () {
      return !this.$getCookie(`account_${this.$route.params.account_id}_tutorial`)
    },
    isKonverza () {
      return (new RegExp('^konverza', 'i')).test(this.account.type)
    },
    navigationMenu () {
      return this.menuList.map(element => {
        element.plugins = this.parsedPlugins.filter(plug => element.paths.includes(plug.name))

        return element
      })
    }
  },
  methods: {
    ...mapActions(['organization/get', 'account/get', 'organization/getPlugins']),
    getOrganization () {
      const self = this

      this['organization/get']({
        organization_id: self.account.organization_id
      })
    },
    getAccount () {
      const self = this

      this['account/get']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.success) {
            self.getOrganization()
            self.getOrganizationPlugins()
          }
        }
      })
    },
    getOrganizationPlugins () {
      const self = this

      this['organization/getPlugins']({
        organization_id: self.account.organization_id,
        callback: res => {
          self.scrollToActiveElement()

          EventBus.$emit('plugins:loaded')
        }
      })
    },
    scrollToActiveElement () {
      this.$nextTick(() => {
        let active = $('.navigation-menu .navigation-ul .navigation-li.router-link-exact-active')[0]
        if (active) {
          active = $(active)

          $('.navigation-ul').scrollTop(0)
          $('.navigation-ul').scrollTop(active.offset().top - $($('.header-section.bb-1.pb-3')[0]).height() - 56)
        }
      })
    },
    isSectionActive (name) {
      const matched = this.$route.matched
      const matchedNames = matched.map(element => element.name)

      if (name === 'Inbox' && matchedNames.includes('Chats')) return false
      if (name === 'Services' && matchedNames.includes('Service')) return true

      return matched.some(element => element.name === name)
    },
    isSomeActive(paths) {
      const plugins = this.parsedPlugins.filter(element => paths.includes(element.name))

      return plugins.some(plugin => this.isSectionActive(plugin.name))
    }
  },
  mounted () {
    this.getAccount()
  },
  components: {
    SidenavAccountInfo
  }
}
</script>

<style lang="scss" scoped>
  .navigation-menu {
    z-index: 999;
    width: 100%;
    height: 100%;
    background-color: white;
    display: flex;
    flex-flow: column;

    .header-section {
      flex-grow: 0;
    }

    .close-button {
      display: block;
      text-align: right;
      cursor: pointer;
      padding: 30px 30px 0;
    }

    .section-title {
      display: flex;
      flex-flow: column;
      font-size: 20px;
      font-weight: 500;
      padding: 30px 30px 0;

      span:not(:last-child) {
        margin-bottom: 5px;
      }

      .sub {
        font-size: initial;
        font-weight: 400;
      }
    }

    .navigation-ul {
      list-style-type: none;
      margin: 0;
      padding: 30px 0;
      flex-grow: 1;

      .navigation-li {
        cursor: default;
        padding: 10px 30px;
        display: block;
        text-decoration: none;
        color: #6e84a3 !important;
        border-left: 2px solid transparent;
        cursor: pointer;

        .navigation-icon {
          margin-right: 10px;
        }

        &:hover {
          color: black !important;
        }

        &:hover, &.router-link-exact-active, &.route-matched-active {
          color: black !important;
          border-left: 2px solid #0e5ccf;
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
          background: rgba(14, 92, 207, .1);

          &.negative-route {
            background: rgba(230, 55, 87, .1);
            border-left: 2px solid #e63757;
          }
        }

        &:not(:last-child) {
          margin-bottom: 10px;
        }

        &.section {
          svg.collapse-chevron-icon {
            transition: .3s;
          }

          &[aria-expanded=true] {
            svg.collapse-chevron-icon {
              transform: rotate(-180deg);
            }
          }
        }

        .collapse .navigation-li:last-child {
          margin-bottom: 10px !important;
        }

        &.not-collapsed {
          color: var(--primary) !important;
        }
      }
    }
  }
</style>
